import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
